import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

const PATHS = {
  hero: [
    "M-20 120 C 120 40, 280 200, 420 80 S 720 20, 900 140",
    "M-40 280 C 180 360, 340 180, 520 300 S 800 420, 980 260",
  ],
  wave: [
    "M0 50 Q 250 0, 500 50 T 1000 50",
    "M0 55 Q 250 95, 500 55 T 1000 55",
  ],
  arc: [
    "M 0 200 Q 500 -40, 1000 200",
  ],
};

/**
 * Decorative SVG paths — draw-in on scroll, gentle flow loop.
 */
export const BackgroundPaths = ({
  variant = "hero",
  className = "absolute inset-0 w-full h-full",
  stroke = "rgba(158, 74, 98, 0.12)",
  strokeWidth = 1.2,
}) => {
  const reduced = usePreferStaticUI();
  if (reduced) return null;

  const paths = PATHS[variant] || PATHS.hero;

  return (
    <svg
      className={className}
      viewBox="0 0 1000 400"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      {paths.map((d, i) => (
        <motion.path
          key={i}
          d={d}
          fill="none"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          initial={reduced ? { pathLength: 1, opacity: 0.5 } : { pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: reduced ? 0 : 2.2 + i * 0.4, ease: "easeInOut" }}
        />
      ))}
    </svg>
  );
};

export default BackgroundPaths;
